"use client"

import { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { getSettings } from "../../utils"
import { apiClient } from "../../api/client"
import Spoke from "./spoke"
import { useLanguage } from "../../../../../contexts/LanguageContext"

const FlashCards = ({ onFinish }) => {
  const { t } = useLanguage();
  const [num, setNum] = useState(0)
  const [displayStep, setDisplayStep] = useState(0)
  const [step, setStep] = useState(0)

  const timerRef = useRef(null)
  const settingsRef = useRef(null)

  useEffect(() => {
    settingsRef.current = getSettings("cards")
    nextStep()

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  const nextStep = async () => {
    let number = "--";
    try {
      number = await apiClient.getNextNumber(step, num, {
        ...settingsRef.current,
        theme: 0,
        difficulties: [settingsRef.current.difficult],
      })
      const newNum = eval(`${num}${number}`)
      setNum(newNum)
      setDisplayStep(0)
    } catch (e) {
      console.log(`${num} - ${step} - ${number} - ${e.message}`)
    }

    timerRef.current = setTimeout(() => {
      hideCard()
    }, settingsRef.current.speed * 1000)

    setStep((prev) => prev + 1)
  }

  const hideCard = () => {
    setDisplayStep(1)
    timerRef.current = setTimeout(() => {
      showResult()
    }, 1000)
  }

  const showResult = () => {
    setDisplayStep(2)
    timerRef.current = setTimeout(() => {
      nextStep()
    }, 1000)
  }

  return (
    <div>
      <h2>{t("performExercise")}</h2>
      <section>
        {displayStep === 0 ? (
          <div style={{ textAlign: "center" }}>
            {`${num}`.split("").map((c, index) => (
              <Spoke key={index} num={c} speed={0} />
            ))}
          </div>
        ) : displayStep === 2 ? (
          <div className="example">{num}</div>
        ) : (
          <div />
        )}
      </section>
      <footer>
        <button onClick={() => onFinish()}>
          <svg fill="#FFF" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <rect
              strokeWidth={2}
              width="17"
              height="20"
              x="4"
              y="2" />
          </svg>
          <div>{t("stop")}</div>
        </button>
      </footer>
    </div>
  )
}

FlashCards.propTypes = {
  onFinish: PropTypes.func.isRequired,
}

export default FlashCards
